import { createContext, useContext } from 'react'
import { Studio } from 'Core/Studio'

export const StudioContext = createContext<Studio | undefined>(undefined)

export const useStudio = () => {
    const studio = useContext(StudioContext)
    if (!studio) {
        throw new Error('useStudio must be used within an StudioContext')
    }
    return studio
}

export const StudioProvider = StudioContext.Provider
